<template>
  <div class="container">
    <header class="d-flex align-items-center justify-content-between py-3">
      <a href="/" class="mb-md-0 logo">
        <img src="./images/logo.png" alt="">
      </a>
      <NavBar></NavBar>
      <div class="wapHide">
        <div class="d-flex align-items-center ">
          <div class="telPhone text-end d-flex align-items-center">
            <i class="iconfont icon-dianhua2 me-1 fs-5"></i>
            <span>186-1269-8839</span>
          </div>
          <router-link to="/agent" class="text-decoration-none py-1 px-3 fs-14 ms-3 rounded-4 agentBtn">智能体服务
          </router-link>
          
        </div>
      </div>
    </header>
    <router-link to="/agent" class="text-decoration-none wapAgentBtn">
      <img src="../../assets/images/agent/ai.png" alt="">
          </router-link>
  </div>
</template>
<script>

import NavBar from './NavBar.vue';
export default {
  name: 'PageHeader',
  props: {
    msg: String
  },
  components: {
    NavBar
  }
}
</script>
<style lang="less" scoped>
  .logo{
    img{
      height: 40px;
    }
  }
  .telPhone{
    .iconfont{
      font-size: 18px;
    }
  }
  .agentBtn{
    background: #0054c6;
    color: #fff;
  }
  .wapAgentBtn{
    display: none;
  }
   @media (max-width: 991.98px) {
     .logo{
        img{
          height: 38px;
        }
      }
      .wapAgentBtn{
        display: block;
        position: fixed;
        right: 0;
        top: 40%;
        z-index: 3;
        img{
          width: 60px;
          animation: pulseBasic .6s infinite;
        }
      }
    // .agentBtn{
    //    display: none !important;
    // }
    // .telPhone{
    //   display: none !important;
    // }
   }
   @keyframes pulseBasic {
      0%, 100% {
          transform: scale(1);
          // box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
      }
      50% {
          transform: scale(1.08);
          // box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
      }
  }
</style>